'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ChartCollateralAtRiskLoading } from '../ChartCollateralAtRisk';
import { LiquidationDetailDataListLoading } from '../LiquidationDetailsDataList/states';
import LiquidationSectionLayout from '../LiquidationSectionLayout';
import { LiquidationsTableLoading } from '../LiquidationTable';
const LiquidationSectionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LiquidationSectionLayout detailsCardsSlot={<LiquidationDetailDataListLoading />} chartSlot={<ChartCollateralAtRiskLoading />} tableSlot={<LiquidationsTableLoading />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(LiquidationSectionLoading);